import { useSelector } from 'react-redux';

import Banner from '../components/banner';
import BuyFlowCart from '../components/buy-flow/cart';
import Payment from '../components/payment';
import { FlexContainerRowLRPadding, PageWrapper } from '../components/styled/skylab/page';
import conf from '../conf';
import { selectState } from '../selectors';

const PaymentPage = () => {
  const {
    buyFlow: { hideIframe },
    system: { activeFlow, isMobile },
  } = useSelector(selectState);

  const activeFlowIsAvataxBuy = activeFlow === 'avatax-buy' || activeFlow === 'avatax-direct-buy';

  return (
    <>
      {activeFlowIsAvataxBuy && (
        <Banner
          backgroundImage={`${conf.ASSET_PATH}/assets/images/banner-background.png`}
          image={`${conf.ASSET_PATH}/assets/images/payment_w.svg`}
          primaryText='Purchase your subscription'
        />
      )}
      <PageWrapper>
        <FlexContainerRowLRPadding offsetRight={50} forceMobile={isMobile}>
          <Payment hideIframe={hideIframe} />
          <div>{activeFlowIsAvataxBuy && <BuyFlowCart isPaymentPage={true} />}</div>
        </FlexContainerRowLRPadding>
      </PageWrapper>
    </>
  );
};

export default PaymentPage;
